export default "__VITE_ASSET__e65709ff__"